<template>
  <div>
    <div class="flex items-center px-4 py-4 flex-wrap">
      <div class="w-6/12">
        {{ header }}
      </div>
      <div class="w-6/12 justify-end flex">
        <!-- <div class="table__search-input-wrapper w-[350px] opacity-75">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input type="text" class="table__search-input" placeholder="Search..." />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div> -->
      </div>
    </div>
    <div class="w-full flex justify-center py-6 relative">
      <div class="middle-text">
        <div class="w-auto text-center inner-content">
          <b class="w-full block">₦ {{ formattedTotal }}</b>
          <span class="w-full block opacity-50">Total</span>
        </div>
      </div>
      <apexchart type="donut" width="380" :options="chartOptions" :series="series"></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
    },
    itemsValues: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // chart series = terminal counts
    series() {
      if (!this.itemsValues?.terminals) return [];
      return this.itemsValues.terminals.map((t) => t.count || 0);
    },

    // slice labels = terminal names
    labels() {
      if (!this.itemsValues?.terminals) return [];
      return this.itemsValues.terminals.map((t) => t.name);
    },

    // raw numeric total (prefer totalAmount, else sum of terminal amounts, else 0)
    rawTotal() {
      if (!this.itemsValues) return 0;

      // prefer explicit totalAmount if provided
      if (this.itemsValues.totalAmount !== undefined && this.itemsValues.totalAmount !== null) {
        return Number(this.itemsValues.totalAmount) || 0;
      }

      // else derive from terminals amounts
      if (Array.isArray(this.itemsValues.terminals) && this.itemsValues.terminals.length) {
        return this.itemsValues.terminals.reduce((sum, t) => sum + (Number(t?.amount) || 0), 0);
      }

      // fallback to totalCount if present (less likely for currency)
      if (this.itemsValues.totalCount !== undefined && this.itemsValues.totalCount !== null) {
        return Number(this.itemsValues.totalCount) || 0;
      }

      return 0;
    },

    // formatted total string (no currency sign)
    formattedTotal() {
      const formatter = new Intl.NumberFormat("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(this.rawTotal);
    },

    // chart options
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: [
          "#09B78A",
          "#D72638",
          "#FCC210",
          "#10233E",
          "#6C63FF",
          "#FF6B6B",
          "#4ECDC4",
        ], // add more colors for terminals
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: { show: false },
                value: { show: false },
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => this.totalValue,
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { show: false },
            },
          },
        ],
        legend: { show: true, position: "bottom" }, // enable legend
        labels: this.labels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.middle-text {
  @apply absolute w-full h-full top-0 left-0 flex justify-center items-center;
}

.inner-content {
  @apply relative;
  top: -16px;
}
</style>
